import { lazy } from 'react';

export const ForgotPasswordPage = lazy(() => import('./ForgotPasswordPage'));
